
//Dropdown nav toggle - (Desktop)
(function($) { "use strict";

	$(".main-nav > ul > li.has-children").click(function() { //Main nav item clicked
		if(!$(this).hasClass('js-nav-current')) { //If not the currently active item
			$("body").addClass("js-nav-active"); //Add body class
			$(".main-nav > ul > li").removeClass("js-nav-current"); //Remove all current item classes
			$(this).addClass("js-nav-current");//Add current item class to this
		} else { //Currently active item was clicked so we should close the dropdown
			$("body").removeClass("js-nav-active"); //Remove body class
			$(".main-nav > ul > li").removeClass("js-nav-current"); //Remove all current item classes
		}
	});
	
	$(".main-nav__overlay").click(function() { //Overlay part clicked so we should close the dropdown
		$("body").removeClass("js-nav-active"); //Remove body class
		$(".main-nav > ul > li").removeClass("js-nav-current"); //Remove all current item classes
	});


	//check first section background, if it is dark make navigation text colour to light
	if ( $('section:first').is('.is-style-bg-colorBlack, .is-style-bg-textureBlack')) {
		//set menu color to black.
		$('body').addClass('main-header_colorWhite');
	}

	//For some backgrounds, change logo to white and colour version
	if ( $('section:first').is('.is-style-bg-colorBlack, .is-style-bg-textureBlack')) {
		//set menu color to black.
		$('body').addClass('main-header_logo_whiteAndColours');
	}

	//For other backgrounds, change logo to all black version
	if ( $('section:first').is('.is-style-bg-colorOrange, .is-style-bg-textureOrange')) {
		//set menu color to black.
		$('body').addClass('main-header_logo_allBlack');
	}

	//set menu accent to white when the first section is orange (or texure orange)
	if ( $('section:first').is('.is-style-bg-colorOrange, .is-style-bg-textureOrange')) {
		//set menu color to black.
		$('body').addClass('main-header_accentWhite');
	}

	//set menu accent to purple for cultural partners
	$('body.single-cultural_partner, body.page-cultural-partners').addClass('main-header_accentPurple')


})(jQuery);



// Hiding/showing main nav on scroll (Desktop)
(function($) { "use strict";


	// On page load
	var stOnload = $(document).scrollTop();
	
	if (stOnload <= 100) {
		$('.main-nav__wrap').css("visibility", "visible");
	} else {
		$('.main-header').addClass('js-nav-hidden');
		setTimeout(function() {
			$('.main-nav__wrap').css("visibility", "visible");
		}, 2000);
	}

	// Hide bar on on scroll down
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	// var navbarHeight = $('.main-header').outerHeight();
	var triggerHeight = 5; //trigger hiding straight away

	$(window).scroll(function(event){
		didScroll = true;
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 1000);


	function hasScrolled() {

		var st = $(document).scrollTop();

		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
			return;

		// If they scrolled down, and past 'triggerHeight', hide the nav 
		if (st > lastScrollTop && st > triggerHeight){
			if ($("body").hasClass("js-mobile-nav-active")) {
				//do not hide the nav if it has been clicked
			} else {
				$('.main-header').removeClass('js-nav-sticky').addClass('js-nav-hidden');
			}
		} else {
			// If they scrolled Up
			if(st + $(window).height() < $(document).height()) {
				// $('.main-header').css("visibility", "visible");
				$('.main-header').removeClass('js-nav-hidden').addClass('js-nav-sticky');
			}
			// If they got back to the top, revert the nav
			if (st < lastScrollTop && st < triggerHeight) {
				$('.main-header').removeClass('js-nav-sticky');
			}
		}

		lastScrollTop = st;
	}


})(jQuery);



//copy the color classes is-bg-? and is-fg-? from the first section to the body, so the navigation is color-compatible
(function($) { "use strict";

	// pages with a hero slider work different
	if( $('.js-hero-slider').length == 0 ) {

		// find the first section in the section container
		const $first_section = $('.section-container > section:first-child');

		if ($first_section.length) {
			//add js-hero-if-bg-? and js-hero-is-fg-? classes to body, following the NEXT slide color scheme
			const current_classes = $first_section.attr('class').split(/\s+/);

			$.each(current_classes, function(index, classname) {
				if (classname.startsWith('is-style-fg-') || classname.startsWith('is-style-bg-')) {
					$('body').addClass('js-hero-' + classname);
				}
			});
		}

	}

})(jQuery);




//Mobile Nav
(function($) { "use strict";

	$(".js-toggle-mobile-nav").click(function() { // Hamburger menu icon clicked
		$("body").toggleClass("js-mobile-nav-active"); //Toggle body class to reflect menu state
	});

	$(".mobile-nav > ul > li.has-children").click(function() { //Main nav item clicked	
		if (!$(this).hasClass('js-mobile-nav-current')) { //If not the currently active item was clicked
			$('.js-mobile-nav-current ul').slideUp(); //Slide up other open sub-menus
			$(".mobile-nav > ul > li").removeClass("js-mobile-nav-current"); //Remove all current item classes
			$(this).addClass("js-mobile-nav-current");//Add current item class to this
			$(this).find('ul').slideDown(); //Slide down sub-menu for this menu item
		} else { //Currently active item was clicked so we should close the dropdown
			$(this).find('ul').slideUp(); //Slide up sub-menu for this menu item
			$(this).removeClass("js-mobile-nav-current"); //Remove current item class
		}
	});
	

})(jQuery);
